import { render, staticRenderFns } from "./EditCostPricesAdditionalFee.vue?vue&type=template&id=193b9dc7"
import script from "./EditCostPricesAdditionalFee.vue?vue&type=script&lang=js"
export * from "./EditCostPricesAdditionalFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports